import { api } from "@/lib/api-client";
import type { AuthUser, LoginInput, LoginResponse } from "./types";

/**
 * Auth endpoints. Pure request functions — no React, no state.
 * Hooks in hooks.ts wrap these with TanStack Query.
 */
export const authApi = {
  login: (input: LoginInput) =>
    api.post<LoginResponse>("/auth/login", input, { skipRefresh: true }),

  logout: () => api.post<void>("/auth/logout", undefined, { skipRefresh: true }),

  me: () => api.get<AuthUser>("/auth/me"),
};
